import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-alipay',
    templateUrl: './alipay.component.html',
    styleUrls: ['./alipay.component.scss'],
    standalone: false
})
export class AlipayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
